import { DataModel } from "common/models/utility-models/base-model";

export class MentorMappingFilterModel extends DataModel {
    batch:string="";
    branch:string="";
    mentor_name:string ="";
    search:string="";
}